import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useSport } from '../contexts/SportContext';

const EmojiRainIntro = ({ onComplete }) => {
  const { t } = useTranslation();
  const { sportTypes } = useSport();
  const [phase, setPhase] = useState('rain'); // rain -> logo -> tagline -> fade
  const [emojis, setEmojis] = useState([]);

  useEffect(() => {
    const sportEmojis = Object.values(sportTypes).map(sport => sport.icon);
    const letters = ['G', 'O', 'N', 'K', 'L', 'E'];

    // Emojis bilden "GONKLE"
    const emojiArray = letters.map((letter, i) => ({
      id: i,
      letter,
      emoji: sportEmojis[i % sportEmojis.length],
      x: 15 + i * 13, // Horizontal verteilt
      delay: 0
    }));
    setEmojis(emojiArray);

    // Nach 2s: Runterfallen
    const fallTimer = setTimeout(() => setPhase('fall'), 2000);

    // Nach 4s: Komplett beenden
    const completeTimer = setTimeout(() => onComplete(), 4000);

    return () => {
      clearTimeout(fallTimer);
      clearTimeout(completeTimer);
    };
  }, [sportTypes, onComplete]);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: phase === 'fade' ? 0 : 1 }}
      transition={{ duration: 0.5 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'var(--color-background)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        overflow: 'hidden'
      }}
    >
      {/* Emojis als "GONKLE" */}
      {emojis.map((item) => (
        <motion.div
          key={item.id}
          initial={{ y: -100, x: `${item.x}vw`, opacity: 0 }}
          animate={{
            y: phase === 'rain' ? '45vh' : '110vh',
            opacity: phase === 'rain' ? 1 : 0,
            rotate: phase === 'fall' ? 360 : 0
          }}
          transition={{
            y: { duration: phase === 'fall' ? 2 : 0.8, ease: phase === 'fall' ? 'easeIn' : 'easeOut' },
            opacity: { duration: 0.3 },
            rotate: { duration: 2 }
          }}
          style={{
            position: 'absolute',
            fontSize: 'clamp(3rem, 10vw, 5rem)',
            userSelect: 'none',
            fontWeight: 'bold',
            color: 'var(--color-accent)',
            textShadow: '0 0 30px var(--color-accent)'
          }}
        >
          {item.letter}
        </motion.div>
      ))}
    </motion.div>
  );
};

export default EmojiRainIntro;
